import {
  faClosedCaptioning as CC,
  faHighDefinition,
  faArrowDownToBracket,
  faArrowUpRightFromSquare,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { convertTime } from '../../shared/util/helperfunctions';

export function McMediaDescription({ masterclass, nowActive, chapterNo, day }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="description">
        <h1 className="title">{nowActive.title.replace(/&amp;/gi, '&')}</h1>
        <div className="tag-line">
          <div>
            {day && `Day ${day}, `}Chapter {chapterNo}
          </div>
          <div>{convertTime(nowActive.length)}</div>
          <FontAwesomeIcon icon={faHighDefinition} />
          <FontAwesomeIcon icon={CC} />
        </div>
        <div className="text">{nowActive.description}</div>
      </div>
      <div className="button-container">
        {masterclass.resources && (
          <a
            href={masterclass.resources}
            rel="noopener noreferrer"
            target="_blank"
            className="mimicButtonLink"
          >
            <div className="mimicButton">
              <FontAwesomeIcon icon={faArrowDownToBracket} className="icon" /> {t('M002')}
            </div>
          </a>
        )}
        {masterclass.signposting && (
          <a
            href={masterclass.signposting}
            rel="noopener noreferrer"
            target="_blank"
            className="mimicButtonLink"
          >
            <div className="mimicButton">
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="icon" />
              {t('M001')}
            </div>
          </a>
        )}
      </div>
    </>
  );
}
